import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { CssBaseline, Box } from "@mui/material";
import { QueryClient, QueryClientProvider } from "react-query";

// Komponenten
import Navigation from "./components/Navigation";
import MapView from "./components/MapView";
import RoutePlanner from "./components/RoutePlanner";
import TrafficInfo from "./components/TrafficInfo";
import Incidents from "./components/Incidents";

// Theme erstellen
const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#dc004e",
    },
    background: {
      default: "#f5f5f5",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

// React Query Client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Box
            sx={{ display: "flex", flexDirection: "column", height: "100vh" }}
          >
            <Navigation />
            <Box component="main" sx={{ flexGrow: 1, overflow: "hidden" }}>
              <Routes>
                <Route path="/" element={<MapView />} />
                <Route path="/route" element={<RoutePlanner />} />
                <Route path="/traffic" element={<TrafficInfo />} />
                <Route path="/incidents" element={<Incidents />} />
              </Routes>
            </Box>
          </Box>
        </Router>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
